import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["transferFields", "transferTempLabel"];

  connect() {
    // Initialize the form state on page load
    this.updateTransferFields();
  }

  toggleTransferFields() {
    // Use setTimeout to ensure the switch has updated its state first
    setTimeout(() => {
      this.updateTransferFields();
    }, 10);
  }

  updateTransferFields() {
    // Check the hidden input value from the switch component
    const transfersInput = this.element.querySelector(
      'input[name="support_agent_phone[forwarding_enabled]"]'
    );
    const transfersEnabled = transfersInput?.value === "true";

    // Show/hide transfer fields
    if (this.hasTransferFieldsTarget) {
      if (transfersEnabled) {
        this.transferFieldsTarget.classList.remove("hidden");
      } else {
        this.transferFieldsTarget.classList.add("hidden");
      }
    }

    // Update transfer temperature label
    if (this.hasTransferTempLabelTarget) {
      this.transferTempLabelTarget.textContent = transfersEnabled
        ? "How easily the agent transfers calls (0-3, higher = fewer transfers)"
        : "How easily the agent will take a call back ticket if the customer refuses to speak to an AI (0-3, higher = harder to create a ticket)";
    }
  }
}
